module.exports = __webpack_public_path__ + "static/media/gret.11ebf90b.mp3";